import type {ReactElement} from 'react';
import type {VersionHistoryOverlayProps} from './version-history-overlay.types';
import {CircularProgressLoader, LOADER_COLOR, LOADER_SIZE} from '@Components/circular-progress-loader';
import {Text, TextSize, TextType} from '@Components/text';
import {formatTime, getDateAndMonthStringWithOrdinal} from '@Utils/date.util';
import {useAppSelector} from '@/hooks';
import style from './version-history-overlay.module.scss';

export default function VersionHistoryOverlay({...props}: VersionHistoryOverlayProps): ReactElement<any> {
  const versionHistorySelectedVersion = useAppSelector((state) => {
    return state.posterEditor.versionHistorySelectedVersion;
  });

  const isMobileVariant = useAppSelector((state) => {
    return state.posterEditor.isMobileVariant;
  });

  const getLoadingTextSize = (): TextSize => {
    return isMobileVariant ? TextSize.XXSMALL : TextSize.SMALL;
  };

  const getVersionDateTextSize = (): TextSize => {
    return isMobileVariant ? TextSize.XXSMALL : TextSize.XSMALL;
  };

  const getLoadingText = (): ReactElement | null => {
    return (
      <div className="flex-column-align-center text-center">
        {versionHistorySelectedVersion ? (
          <>
            <Text size={getLoadingTextSize()} type={TextType.BODY} bold={true} className="content-body-white" val={window.i18next.t('pmwjs_fetching_version')} />
            <Text
              size={getVersionDateTextSize()}
              type={TextType.BODY}
              className="content-body-white"
              val={`${formatTime(versionHistorySelectedVersion.createdOn)}, ${getDateAndMonthStringWithOrdinal(new Date(versionHistorySelectedVersion.createdOn * 1000))}`}
            />
          </>
        ) : null}
      </div>
    );
  };

  return (
    <div className={`${props.className ?? ''} ${style.overlay} _position-absolute _full-width _full-height flex-center`}>
      <div className="flex-column-align-center gap-2 text-center">
        <CircularProgressLoader size={LOADER_SIZE.DEFAULT} color={LOADER_COLOR.WHITE} classes="spacing-m-0" />
        {getLoadingText()}
      </div>
    </div>
  );
}
